<script>
import {defineComponent} from "vue";
import headtip from "@/views/headTip.vue";
import consultTip from "@/components/consultTip.vue";

export default defineComponent({
  components: {consultTip, headtip},
  data(){
    return{
      dialogVisible: false,
      title: 'GPT Assistants',
      items: [
        {
          name: 'ByteDance ArkClaw',
          description: 'Deeply integrated with Feishu ecosystem, one-click low-code deployment.Rapidly implement your AI Agent and efficiently empower business collaboration!',
          url: 'https://console.volcengine.com/ark/claw ',
          image: require('@/assets/openclaw/zijie.svg'),
        },
        {
          name: 'Tencent WorkBuddy',
          description: 'Deeply integrated with WeCom and QQ, one-click connection between team communication and task workflows, fully enhancing collaboration efficiency for a smoother office experience.',
          url: 'https://www.codebuddy.cn/work',
          image: require('@/assets/openclaw/tengxun.svg'),
        },
        {
          name: 'Huawei OpenClaw',
          description: 'One-click HUAWEI CLOUD deployment, high security & compliance, a robust tech base for enterprise AI.',
          url: 'https://activity.huaweicloud.com/openclaw.html',
          image: require('@/assets/openclaw/huawei.svg'),
        },
        {
          name: 'Alibaba OpenClaw',
          description: 'AgentBay-powered enterprise hosting, cloud-native ready, elastic scaling & efficient AI operations.',
          url: 'https://www.aliyun.com/activity/ecs/clawdbot',
          image: require('@/assets/openclaw/ali.svg'),
        },
        {
          name: 'Baidu OpenClaw',
          description: 'Get started in 3–5 minutes, accessible directly via the app search box.Out-of-the-box, enabling easy development of industry AI applications.',
          url: 'https://console.bce.baidu.com/qianfan/studio/openclaw',
          image: require('@/assets/openclaw/baidu.svg'),
        },
        {
          name: 'Kimi Claw',
          description: 'Powered by Kimi LLM, superior document Q&A, one-click ecosystem integration for intelligent knowledge management and office efficiency!',
          url: 'https://www.kimi.com/bot',
          image: require('@/assets/openclaw/kimi.svg'),
        },
      ]
    }

  },
  methods:{
    clickConsult(item) {

      console.log(item)
      this.title = item
      this.dialogVisible = true;
      sessionStorage.setItem('title', item)
    },
    hideDialog() {
      localStorage.setItem("skip", 0)
      this.dialogVisible = false;
    },

  }
})
</script>

<template>
  <div class="assistantsContainer">
    <div class="header" style="padding:1.5vh 5vw;background-color: #f2f1f4">
      <headtip @showDialog="showPartner"></headtip>
    </div>
    <a href="/">
      <div style="position: absolute;top: 70px;left: 10px">
        <img style="width: 40px;height: 20px" src="@/assets/back1.png">
      </div>
    </a>

    <div class="title1">Open Claw</div>
    <div class="assistants" style="display: grid;grid-template-columns: minmax(0,1fr) ;padding: 0 5vw;margin-top: 6vh">
      <a v-for="item in items" :key="item.name" :href="item.url" target="_blank">
        <div class="assistant" >
          <img :src="item.image">
          <div class="contentDesign">
            <div class="t1">{{ item.name }}</div>
            <div class="t2">
              {{ item.description }}
            </div>
          </div>
        </div>
      </a>
    </div>
    <consultTip
        :thisTitle="title"
        :dialogVisible="dialogVisible"
        @hideDialog="hideDialog"
    ></consultTip>
  </div>
</template>

<style scoped lang="scss">
.assistantsContainer{
  width: 100%;
  .topback {
    position: fixed;
    z-index: 9;
    width: 100vw;
    padding: 0 0 0 2.86077411900635vw;
  }
  .title1{
    font-size: 6vw;
    margin: 1vh  auto auto;
    padding: 2vh 0;
    text-align: center;
    font-weight: bolder;
  }
  .title2{
    font-size: 4vw;
    text-align: left;
  }
  .assistant{
    margin: 1vh 2vh;
    padding: 2vh;
    border-radius: 9px;
    //padding: 4vh 6vw 4vh 2vw;
    display: flex;
    align-items: center;
    background-color: white;
    //border: 1px solid gray;
    img{
      width: 12vw;
      height: 12vw;
    }
    .contentDesign{
      margin-left: 4vw;
      .t1{
        font-size: 4vw;
        font-weight: bolder;
      }
      .t2{
        margin-top: 1vh;
        font-size: 3vw;
      }
    }
  }
}

</style>
